












































































































































































































































































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AccomodationUnitTypeViewModel } from "@/shared/models/accomodationUnitTypeViewModel";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import PriceInput, { PriceChange } from "../../calendar/inputs/PriceInput.vue";
import { formatLocaleNumber } from "@/components/numbers/numberFormatUtils";
import { OfficialRateModel, OfficialRateRuleModel } from "./types";
import { OwnerPricingModelEnum } from "@/shared/models/enums.type";
import { autoCalculateAbsolutePrice, autoCalculatePrice, autoCalculatePriceWhenRelative, calculatePrice, round } from "@/components/numbers/numberFormatUtils";

@Component({
  components: {
    NumericInputImproved,
    PriceInput,
  },
})
export default class OfficialRatesOBRules extends Vue {
  @PropSync("officialRate") officialRateInternal?: OfficialRateModel;
  @PropSync("saving") savingInternal?: boolean;
  @Prop() accUnitType?: AccomodationUnitTypeViewModel;

  @Getter("appParams/tenantUsesInputPrice") tenantUsesInputPrice?: boolean;

  @Getter("language/language") language?: string;

  getRuleHeader(obr: OfficialRateRuleModel) {
    return obr.minPersons === obr.maxPersons
      ? `${obr.minPersons} pax`
      : `${obr.minPersons}-${obr.maxPersons} pax`;
  }

  isBaseRule(obr: OfficialRateRuleModel) {
    return (obr.isDefaultPAXCategory)
  }

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  get isPricingModelRelative() {
    return (
      this.accUnitType?.propertyOwnerPricingModelId ==
      OwnerPricingModelEnum.Relative
    );
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      zeroOrPositive: (value: any) =>
        value === null ||
        value === undefined ||
        value >= 0 ||
        this.$t("Validation.MustBeZeroOrPositive"),
      undefinedOrPositive: (value: any) =>
        value === undefined ||
        value >= 0 ||
        this.$t("Validation.MustBeZeroOrPositive"),
    };
  }

  fkey = 0;
  automaticCalculationModal = false;

  formatPrice(price?: number) {
    return price != null
      ? formatLocaleNumber(price, 2, this.internalLanguage)
      : "";
  }

  //if user changes 'inputPrice' -> 'priceReference' is outputPrice to calculate from (and the other way around)
  calculatePrice(
      priceChange: PriceChange,
      index: number,
      isMain: boolean,
      userChangedInputPrice: boolean,
      priceReference?: number
    ) {
      if (priceChange) {
        const changeKey = calculatePrice(
          priceChange,
          this.officialRateInternal,
          userChangedInputPrice,
          priceReference,
          { isMain, index }
        );

        if (changeKey) this.fkey++;
      }
    }
  
  calculateAutomaticAbsolutePrice(
    priceChange: PriceChange,
    inputPriceChanged: boolean,
    obr: OfficialRateRuleModel
  ) {
    if (priceChange) {
      autoCalculateAbsolutePrice(priceChange, inputPriceChanged, obr, this.officialRateInternal)
    }
  }

  automaticCalculation(isInputPriceChanged: boolean, index: number) {
    autoCalculatePrice(
      isInputPriceChanged,
      this.officialRateInternal,
      this.accUnitType?.propertyOwnerPayoutPercent ?? 0,
      index,
      undefined
    );
  }
  
  autoCalculateAutomaticRelativePrice(isInputPriceChanged: boolean, obr: OfficialRateRuleModel) {
    if (!this.officialRateInternal) return;
    
    autoCalculatePriceWhenRelative(isInputPriceChanged, obr, this.accUnitType);
  }
  //used in automatic calculation dialog to calculate all prices based on price differences of every category
  autoCalculateAllPrices(obr: OfficialRateRuleModel) {
    if (this.officialRateInternal) {
      for (const item of this.officialRateInternal?.officialRateRules) {
        //skip the main (obr)
        if (item !== obr) {
          let paxInputPricePart = 0;
          let paxOutputPricePart = 0;
          
          if (
            obr.inputPrice &&
            item.obInputPriceDifference &&
            this.tenantUsesInputPrice
          ) {
            paxInputPricePart = item.obInputPriceDifferenceIsAbsolute
              ? item.obInputPriceDifference
              : round(obr.inputPrice * (item.obInputPriceDifference / 100));
          }
          item.inputPrice = round((obr.inputPrice ?? 0) + paxInputPricePart); // Rounding on addition because javascript can behave really weird (for test, try this in console: 0.1 + 0.2 :))

          if (obr.price && item.obOutputPriceDifference) {
            paxOutputPricePart = item.obOutputPriceDifferenceIsAbsolute
              ? item.obOutputPriceDifference
              : round(obr.price * (item.obOutputPriceDifference / 100));
          }
          item.price = round((obr.price ?? 0) + paxOutputPricePart);
        }
      }
    }

    this.closeModal();
  }

  //when pricing model = relative
  //calculate all prices based on input prices price differences
  autoCalculateFromInputPrice(obr: OfficialRateRuleModel) {
    if (this.officialRateInternal) {
      for (const item of this.officialRateInternal?.officialRateRules) {
        //skip the main (obr)
        if (item !== obr) {
          let paxInputPricePart = 0;
          let paxOutputPricePart = 0;
          if (
            obr.inputPrice &&
            item.obInputPriceDifference &&
            this.tenantUsesInputPrice
          ) {
            paxInputPricePart = item.obInputPriceDifferenceIsAbsolute
              ? item.obInputPriceDifference
              : round(obr.inputPrice * (item.obInputPriceDifference / 100));
          }
          item.inputPrice = round((obr.inputPrice ?? 0) + paxInputPricePart); // Rounding on addition because javascript can behave really weird (for test, try this in console: 0.1 + 0.2 :))
          if (obr.price && item.obInputPriceDifference) {
            paxOutputPricePart = item.obInputPriceDifferenceIsAbsolute
              ? item.obInputPriceDifference
              : round(obr.price * (item.obInputPriceDifference / 100));
          }
          item.price = round((obr.price ?? 0) + paxOutputPricePart);
        }
      }
    }

    this.closeModal();
  }

  //when pricing model = relative
  //calculate all prices based on selling prices price differences
  autoCalculateFromOutputPrice(obr: OfficialRateRuleModel) {
    if (this.officialRateInternal) {
      for (const item of this.officialRateInternal?.officialRateRules) {
        //skip the main (obr)
        if (item !== obr) {
          let paxInputPricePart = 0;
          let paxOutputPricePart = 0;
          if (
            obr.inputPrice &&
            item.obOutputPriceDifference &&
            this.tenantUsesInputPrice
          ) {
            paxInputPricePart = item.obOutputPriceDifferenceIsAbsolute
              ? item.obOutputPriceDifference
              : round(obr.inputPrice * (item.obOutputPriceDifference / 100));
          }
          item.inputPrice = round((obr.inputPrice ?? 0) + paxInputPricePart); // Rounding on addition because javascript can behave really weird (for test, try this in console: 0.1 + 0.2 :))

          if (obr.price && item.obOutputPriceDifference) {
            paxOutputPricePart = item.obOutputPriceDifferenceIsAbsolute
              ? item.obOutputPriceDifference
              : round(obr.price * (item.obOutputPriceDifference / 100));
          }
          item.price = round((obr.price ?? 0) + paxOutputPricePart);
        }
      }
    }

    this.closeModal();
  }

  get baseCategory() {
    const toReturn = (this.officialRateInternal?.officialRateRules ?? []).find(
      (x) => x.isDefaultPAXCategory
    );

    return toReturn ?? null;
  }

  closeModal() {
    this.automaticCalculationModal = false;
  }
}
